module.exports = __webpack_public_path__ + "img/fi-rr-user-remove.746ad5dc.svg";